
import { ISprintViewPivotContext } from "Agile/Scripts/SprintsHub/SprintView/SprintContentViewContracts";
import { getDefaultWebContext } from "VSS/Context";
import { HubViewOptionKeys } from "VSSUI/Utilities/HubViewState";

export function getBurndownProps(context:ISprintViewPivotContext)
{
    const reportSettings: SprintBurndownProps = {
        teamId: context.team.id,
        teamName: context.team.name,
        projectId: getDefaultWebContext().project.id,
        iterationPath: context.selectedIteration.iterationPath,
        iterationStartDate: context.selectedIteration.startDateUTC,
        iterationEndDate: context.selectedIteration.finishDateUTC,
        isFullScreen: context.viewOptions.getViewOption(HubViewOptionKeys.fullScreen), //Whenever the full screen state changes, we want to trigger a re-render and get a completion notification back to boards page framework
          // Default props are not for header but for report and these get overridden in the custom LWP caller for header charts or lightbox
        isMinimalChart: false,
        isLightbox: false
    };
    return reportSettings;
}

export interface SprintBurndownProps extends SprintBurndownHeaderChartProps{
    teamId: string;
    teamName: string;
    projectId: string;
    iterationPath: string;
    /** Only intended for diagnosing AX-synchronization issues where iteration is configured, but not present in AX. */
    iterationStartDate: Date,
    /** Only intended for diagnosing AX-synchronization issues where iteration is configured, but not present in Ax. */
    iterationEndDate: Date,
    lastRefresh?: Date;
    onLoadCompleted?: () => void;
    isFullScreen: boolean; // The reports don't directly care about this property, we just need to react to the state change so our menu options aren't clobbered.
}

interface SprintBurndownHeaderChartProps{
    isMinimalChart?: boolean; // Flag to render minimal chart in the agile header
    isLightbox?: boolean; // Flag for lightbox implementation
}